<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="付款申请详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="payApplyNumber"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate
          :current="detailInfo"
          @success="getPaymentApplyDetail"
        />
      </div>
      <div v-loading="loading">
        <div class="main-cont">
          <div class="detail-title-name">
            {{detailInfo.businessName || '-'}}
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="_setStatusColor(detailInfo.approvalStatus, viewStatusType)"
                :status="detailInfo.approvalStatusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo">
                <template #payReason>
                  <jr-tooltip :content="detailInfo.payReason || '-'" />
                </template>
                <template #orderNumber>
                  <jr-tooltip :content="detailInfo.orderNumber" type="popover" />
                </template>
              </jr-col>
              <jr-col :data-show="secondCol" :data="detailInfo" />
              <jr-col :data-show="thirdCol" :data="detailInfo" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">付款信息</h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="fourthCol" :data="detailInfo" />
              <jr-col :data-show="fifthCol" :data="detailInfo">
                <template #bankCardNumber>
                  <template v-if="detailInfo.payMode === 'ALIPAY' && detailInfo.payWay === 32">
                    <jr-preview-image :image-list="$stringToArray(detailInfo.qrCodeUrl)|| []" :is-link="true" />
                  </template>
                  <span v-else>{{detailInfo.bankCardNumber || '-'}}</span>
                </template>
              </jr-col>
              <jr-col :data-show="sixthCol" :data="detailInfo" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联应收单信息</h2>
            <jr-table
              :size="formSize"
              :tableData="receiveList"
              :tableColumn="tableColumn"
              :pagination="totalCount > 10"
              :total="totalCount"
              :search-params.sync="receiveListParams"
              :loading="receiveListLoading"
              @refresh="refreshList"
            />
          </div>
        </div>
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import { getPaymentApplyDetail, getReceiveList } from '@/api/approval/payment-apply';
import { setStatusColor } from '@/filters/index';
import btnsOperate from './btns-operate';

export default {
  props: {
    paymentNo: {
      type: String,
      default: '',
    },
    payApplyNumber: {
      type: String,
      default: '',
    },
    viewStatusType: {
      type: String,
      default: 'approvalStatus',
    },
  },
  components: { btnsOperate },
  data() {
    return {
      detailInfo: {},
      loading: false,
      isReceiveDetailShow: false, // 详情弹窗
      receiveNo: '', // 应收单编号
      // 基础信息
      firstCol: [
        { label: '付款申请单号:', prop: 'payApplyNumber' },
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '业务类型:', prop: 'busiTypeDesc' },
        { label: '业务单号:', prop: 'orderNumber', slotName: 'orderNumber' },
        { label: '付款原因:', prop: 'payReason', slotName: 'payReason' },
        { label: '付款驳回原因:', prop: 'rejectReason', show: () => this.type !== 'paymentPayable' },
        { label: '服务商名称:', prop: 'payeeBusinessName' },
      ],
      secondCol: [
        { label: '付款金额:', prop: 'payAmount', filters: 'toFenThousandsAndFloat', className: 'detail-amount_num' },
        { label: '付款方式:', prop: 'payModeDesc' },
      ],
      thirdCol: [
        { label: '申请人:', prop: 'cruser' },
        { label: '申请时间:', prop: 'crtime', filters: 'formatTime' },
        { label: '操作人:', prop: 'approvalUser' },
        { label: '审核时间:', prop: 'approvalTime', filters: 'formatTime' },
      ],
      // 付款信息
      fourthCol: [
        { label: '收款银行:', prop: 'bankName' },
        { label: '账户名称:', prop: 'bankAccountName' },
      ],
      fifthCol: [
        { label: '支行名称:', prop: 'bankBranchInfo' },
        { label: '收款账号:', prop: 'bankCardNumber', slotName: 'bankCardNumber' },
      ],
      sixthCol: [
        { label: '账户类型:', prop: 'bankAccountTypeDesc' },
      ],
      tableColumn: [
        { label: '应收单编号', prop: 'receiveNo' },
        { label: '业务订单编号', prop: 'orderNumber' },
        { label: '客户名称', prop: 'businessName' },
        { label: '客户编号', prop: 'businessNo' },
        { label: '创建时间', prop: 'crtime', filterName: 'formatTime' },
        { label: '应收总额', prop: 'shouldRecAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '已确认金额', prop: 'confirmAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '待确认金额', prop: 'waitConfirmAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '待收金额', prop: 'waitRecAmount', filterName: 'toFenThousandsAndFloat' },
        {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => this._setStatusColor(val, 'cancelStatus'),
        },
      ],
      receiveList: [],
      receiveListParams: {
        page: 1,
        limit: 10,
      },
      totalCount: 0,
      receiveListLoading: false,
    };
  },
  watch: {
    paymentNo: {
      deep: true,
      handler() {
        if (this.paymentNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      this._getReceiveList();
      this.getPaymentApplyDetail();
    },
    async _getReceiveList() {
      try {
        this.receiveListLoading = true;
        const res = await getReceiveList({
          ...this.receiveListParams,
          paymentNo: this.paymentNo,
        });
        this.receiveList = res.data || [];
        this.totalCount = res.totalCount || 0;
        this.receiveListLoading = false;
      } catch (error) {
        console.log(error);
        this.receiveListLoading = false;
      }
    },
    // 刷新列表
    refreshList(params) {
      this.receiveListParams = { ...this.receiveListParams, ...params };
      this._getReceiveList();
    },
    _setStatusColor(val, type) {
      return setStatusColor(val, type);
    },
    // 应收单详情
    handleReceiveDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isReceiveDetailShow = true;
    },
    handlePictureCardPreview(file, index, gallery) {
      const viewer = this.$refs[gallery].$viewer;
      viewer.view(index);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.detailInfo = {};
        this.isReceiveDetailShow = false;
        this.init();
      });
    },
    // 获取付款管理详情接口
    async getPaymentApplyDetail() {
      try {
        this.detailInfo = {};
        if (!this.paymentNo) {
          this.$message({
            message: '应付单编号不能为空！！',
            type: 'warning',
          });
          return;
        }
        this.loading = true;
        const res = await getPaymentApplyDetail({ paymentNo: this.paymentNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table-button {
  margin-bottom: 0;
}
</style>

